<lxm-dialog [dialogRef]="dialogRef" [formGroup]="formGroup">
  <span header-title
    >{{'cards.products.product_validation.title' | translate}}</span
  >

  <section body class="flex flex-1 flex-col justify-between">
    <!-- <div class="flex">
      <info-array
        [info]="validationInstructions.text"
        [prelude]="validationInstructions.prelude"
        class="row mb20"
      >
      </info-array>
    </div> -->

    <div class="mt-2 flex flex-col flex-1 gap-8">
      <p>
        {{'cards.products.product_validation.text' | translate}}
      </p>

      <form-field
        label="cards.products.product_validation.label.retailers"
        description="cards.products.product_validation.label_description.retailers"
        class="w-full"
      >
        <lxm-select
          select
          class="w-full"
          labelField="name"
          [searchable]="true"
          for="retailers"
          [multiple]="true"
          [selectAllOption]="true"
          [options]="retailerOptions"
          [sortByLabel]="true"
          compareField="id"
        >
        </lxm-select>
        <validation-errors
          for="retailerIds"
          aliasTo="retailers"
        ></validation-errors>
        <div below class="mt20 flex justify-end">
          <lxm-button
            [disabled]="formGroup.get('retailers').value?.length < 1"
            [loading]="isValidateLoading"
            type="primary"
            label="cards.products.product_validation.action.validate"
            (click)="validateRetailers()"
            *ngIf="!showSummary"
          >
          </lxm-button>

          <div class="flex flex-row gap-4" *ngIf="showSummary">
            <lxm-button
              [disabled]="formGroup.get('retailers').value?.length < 1"
              [loading]="isValidateLoading"
              type="beige"
              height="var(--button-big-height)"
              padding="7px var(--10x)"
              label="cards.products.product_validation.action.validate_again"
              (click)="validateRetailers()"
              class="mr-2"
            >
            </lxm-button>
            <div class="flex items-center gap-3x">
              <svg-icon key="checkGreenSmall" fontSize="14px"></svg-icon>
              <span class="text-viridian font-semibold ml-1">{{'cards.products.product_validation.action.validate_validated' | translate}}</span>
            </div>
          </div>
 
        </div>
      </form-field>
    </div>
    <div class="f-1 flex flex-col" *ngIf="showSummary">
      <!-- <div class="align-center flex flex-row">
        <span class="bold"
          >{{'cards.products.product_validation.summary.summary' |
          translate}}</span
        >
        <span class="ml5" [ngSwitch]="isProductValid">
          <ng-container *ngSwitchCase="false">
            {{'cards.products.product_validation.summary.continue_editing' |
            translate}}
          </ng-container>
          <ng-container *ngSwitchCase="true">
            {{'cards.products.product_validation.summary.product_valid' |
            translate}}
          </ng-container>
        </span>
      </div> -->


      <ng-container [ngSwitch]="isProductValid">

        <card-message type="success" *ngSwitchCase="true">
          <h4 class="mb-3">{{'cards.products.product_validation.summary.success_heading' | translate}}</h4>
          <p>
            {{'cards.products.product_validation.summary.success_heading_text' | translate}}
          </p>
        </card-message>

        <card-message type="warning" *ngSwitchCase="false">
          <h4 class="mb-3">{{'cards.products.product_validation.summary.warning_heading' | translate}}</h4>
          <p>
            {{'cards.products.product_validation.summary.warning_heading_text' | translate}}
          </p>
  
          <div class="invalid-fields-container">
            <div
              class="invalid-fields"
              *ngFor="let group of groupedInvalidFields"
            >
              <div class="invalid-fields--header">
                <status-circle [status]="0" enum="ValidType"></status-circle>
                <p>{{group.sectionTitle}}</p>
              </div>
              <div class="invalid-fields--content">
                <ng-container *ngFor="let field of group.fields; let last = last">
                  {{field}}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </div>
            </div>
            <div
              class="invalid-fields"
              *ngIf="invalidUnitFields as invalidUnitFieldsValue"
            >
              <div class="invalid-fields--header">
                <status-circle [status]="0" enum="ValidType"></status-circle>
                <p>{{'cards.products.product_packaging.title' | translate}}</p>
              </div>
              <div class="invalid-fields--content">
                {{invalidUnitFieldsValue}}
              </div>
            </div>
            <div class="invalid-fields" *ngIf="missingPricesInfoFields?.length">
              <div class="invalid-fields--header">
                <status-circle [status]="3" enum="ValidType"></status-circle>
                <p>
                  {{'cards.products.product_validation.fields.current_price_list' |
                  translate}}
                </p>
              </div>
              <div class="invalid-fields--content">
                <!-- <ng-container *ngFor="let field of missingPricesInfoFields">
                  {{field | translate}}
                </ng-container> -->
                {{'cards.products.product_validation.fields.current_price_list_additional_text' | translate}}
              </div>
            </div>
          </div>
        </card-message>



      </ng-container>

    
    </div>
  </section>

  <section footer [ngSwitch]="hasSummary">
    <ng-container *ngSwitchCase="false">
      <lxm-button
        type="tertiary"
        icon="crossmark-sm"
        label="action.close"
        (click)="closeDialog()"
      ></lxm-button>
    </ng-container>
    <ng-container *ngSwitchCase="true">
      <lxm-button
        type="primary"
        [label]="'cards.products.product_validation.action.start_filling'"
        (click)="closeDialog()"
        *ngIf="!isProductValid"
      ></lxm-button>
      <lxm-button
        type="tertiary"
        label="action.close"
        (click)="isProductValid ? closeDialog() : onCloseAfterValidation()"
      ></lxm-button>
    </ng-container>
  </section>
</lxm-dialog>
